class ComponentAnimation {
  constructor() {
    this._onDomReady();
  }

  private _onDomReady() {
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', () => this._init());
    } else {
      this._init();
    }
  }
  _init() {
    document.documentElement.classList.remove('no-js');

    // Si IntersectionObserver n'existe pas (ancien navigateurs)
    if (!('IntersectionObserver' in window)) {
      document.querySelectorAll<HTMLElement>('[data-animation]').forEach(el => {
        el.classList.add('is-visible');
      });
      return;
    }

    // Sinon Animation !
    const observer = new IntersectionObserver(
      (entries, observer) => {
        entries.forEach(entry => {
          if (entry.isIntersecting) {
            const el = entry.target as HTMLElement;

            if (el.dataset.animation?.startsWith('group')) {
              const children = Array.from(el.children);
              children.forEach((child, index) => {
                const delay = index * 300;
                (child as HTMLElement).style.transitionDelay = `${delay}ms`;
              });
            }

            el.classList.add('is-visible');
            observer.unobserve(el);
          }
        });
      },
      {
        // threshold: 0.1
        threshold: 0,
      }
    );

    document.querySelectorAll<HTMLElement>('[data-animation]').forEach(el => {
      observer.observe(el);
    });
  }
}

export const componentAnimation = new ComponentAnimation();
